define('order_wizard_cartitems_module_pickup_in_store.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_cartitems_module_pickup_in_store', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Packages.Collection\"></div>  ";
},"useData":true}, 'extensions/RSM/Applied_Systems_Theme/1.4.0/', 'extensions/RSM/Applied_Systems_Theme/1.4.0/', Handlebars);
});